import {defineStore} from 'pinia';
import {ModuleDIFixedAsset} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import fixedAssetAPI from '@/apis/di/fixedAssetAPI';
const fixedAssetStore = new BaseDictionaryStore(fixedAssetAPI);

/**
 * store màn danh mục tài sản
 */
export const useFixedAssetStore = defineStore(ModuleDIFixedAsset, {
  state: () => ({
    ...fixedAssetStore.state,
    _config: {
      key: 'fixed_asset_id',
      code: 'fixed_asset_code',
      name: 'fixed_asset_name',
      table: 'di_fixed_asset',
      moduleName: 'Tài sản cố định',
    },
    moduleName: 'fixedAsset',
  }),
  actions: {...fixedAssetStore.action},
  getters: {
    ...fixedAssetStore.getters,
  },
});
